/**
 * @version GENERATOR_VERSION::20200504
 * @DateTime 2020-06-18T19:58:30.528
 * @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
 **/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'storagemanage-deputecontractback-'

export default {
    path: '/storagemanage/deputecontractback',
    name: 'storagemanage-deputecontractback',
    redirect: {
        name: '${pre}-index'
    },

    meta: {
        ...meta,
    },

    component: BasicLayout,
    children: [{
            path: 'index',
            name: '${pre}condeputecontractback-index',

            meta: {
                ...meta,
                title: '退件记录'
            },

            component: () => import('@/pages/storagemanage/condeputecontractback/index'),
        },
        {
            path: 'detail-edit/:id',
            name: '${pre}condeputecontractback-detail-edit',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '退件记录编辑'
            },

            component: () => import('@/pages/storagemanage/condeputecontractback/detail-edit'),
        },
        {
            path: 'detail-edit',
            name: '${pre}condeputecontractbackdetail-create',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '退件记录新增'
            },

            component: () => import('@/pages/storagemanage/condeputecontractback/detail-edit'),
        },
        {
            path: 'detail-view/:id',
            name: '${pre}condeputecontractbackView',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '退件记录详情查看'
            },

            component: () => import('@/pages/storagemanage/condeputecontractback/detail-view'),
        },
    ]
};
